import { useId, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/searchBar.css"
import { SearchInput } from "./SearchInput";

export const SearchBar = ({ onChange }: { onChange: (input: string) => any; }) => {
    const id = useId();
    const [value, setValue] = useState<string>("");
    const { t } = useTranslation("general");

    const handleOnChange = (input: string) => {
        setValue(input);
        onChange(input);
    };

    return (
        <SearchInput
            id={id}
            value={value}
            placeholder={`${t("Search")}...`}
            ariaLabel={t("Search")}
            onChange={handleOnChange} /> 
    );
};
